import React, { useEffect, useState } from "react";
import Label from "../../../../../components/common-components/label/Label";
import Heading from "../../../../../components/common-components/zoom/components/heading/Heading";
import { HEADING } from "../../../../../components/common-components/zoom/constants";
import Table from "../../../../../containers/Table/Index";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Button from "../../../../../components/common-components/button/Button";
import { BUTTON_VARIANTS } from "../../../../../components/common-components/button/Constants";
import {
  getConsentList,
  getConsentRecordsList,
} from "../../PatientDashboardSaga";
import { componentKey, setPaginationState, setPatientId } from "../../PatientDashboardSlice";
import ViewRecords from "../ViewRecords/ViewRecords";
import General from "../../../../../libs/utility/General";

const ConsentList = ({ handleABHAhealthRecord }) => {
  const { patientData, bundlesData, paginationState, consentList } =
    useSelector((state) => state[componentKey]);
  const [isViewRecordsOpen, setIsViewRecordsOpen] = useState(false);
  

  const dispatch = useDispatch();

  const hanldeResfresh = () => {
    const queryData = {
      patientId: patientData.uuid,
      pageNumber: paginationState.pageNumber,
      limit: 5,
    };
    if (patientData.uuid) {
      dispatch(getConsentList(queryData));
    }else{
      const queryData = {
        pageNumber: paginationState.pageNumber,
        limit: 5,
      };
      dispatch(getConsentList(queryData));
    }
  };

  useEffect(() => {
    if (patientData.uuid) {
      const queryData = {
        patientId: patientData.uuid,
        pageNumber: paginationState.pageNumber,
        limit: 5,
      };
      dispatch(getConsentList(queryData));
    }else{
      const queryData = {
        pageNumber: paginationState.pageNumber,
        limit: 5,
      };
      dispatch(getConsentList(queryData));
    }
  }, [paginationState.pageNumber, patientData.uuid, dispatch]);

  const columns = [
    {
      field: "name",
      label: <Label fontWeight="bold">Name</Label>,
      renderLogic: (row) => (
        <div>
        <Heading type={HEADING.H4} customStyle={{ color: "#1B5984" }} fontSize="md">
          {row?.patient?.firstName || row?.patient?.lastName ? (
            <>
          <div className="flex gap-4 text-nowrap">
              {row?.patient?.firstName +" "+row?.patient?.lastName}
            </div>
            </>
          ) : (
            <p className="text-center">-</p>
          )}
        </Heading>
           <p className="text-gray-500">
           {row?.patient?.abhaAddress||"-"}
             </p>
         </div>
      ),
      width: "15%",
    }
    ,
    {
      field: "status",
      label: <Label fontWeight="bold">Request Status</Label>,
      renderLogic: (row) => {
        const statusColorMap = {
          Granted: "text-green-600",
          Rejected: "text-red-700",
          Requested: "text-yellow-500",
          Revoked:"text-rose-500",
          Denied:"text-red-500",
          Expired:"text-amber-700"
        };  
        const status = row?.status;
        const statusClass = statusColorMap[General.toPascalCaseWithSpaces(status)] || "text-gray-500";
        return (
          <span className={`${statusClass} font-medium text-[14px]`}>
            {General.toPascalCaseWithSpaces(status) || <p className="text-center">-</p>}
          </span>
        );
      },
      width: "10%",
    },
    {
      field: "requestedFor",
      label: <Label fontWeight="bold">Requested For</Label>,
      renderLogic: (row) => (
        <>
          {row?.hiTypes?.map((hi, index) => (
            <Heading
              key={index}
              type={HEADING.H4}
              customStyle={{
                color: "#6B7280",
                fontSize: "14px",
                fontWeight: "500",
              }}
              fontSize="md"
            >
              {hi}
            </Heading>
          ))||  <p className="text-center">-</p>}
        </>
      ),
      width: "10%",
     },
     {
      field: "grantedFor",
      label: <Label fontWeight="bold">Granted For</Label>,
      renderLogic: (row) => (
        <>
          {row?.grantedFor?.map((gr, index) => (
            <Heading
              key={index}
              type={HEADING.H4}
              customStyle={{
                color: "#6B7280",
                fontSize: "14px",
                fontWeight: "500",
              }}
              fontSize="md"
            >
              {gr}
            </Heading>
          ))||<p className="text-center">-</p>}
       
        </>
      ),
      width: "10%",
     }
    // {
    //   field: "hiTypes",
    //   label: <Label fontWeight="bold">HI Types</Label>,
    //   renderLogic: (row) => {
    //     const hiTypesData = row.hiTypes
    //       ?.map((type) => ABDM_PROFILES.find((p) => p.value === type))
    //       .filter(Boolean);
  
    //     return (
    //       <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
    //         {hiTypesData.map((item, i) => (
    //           <div
    //             key={i}
    //             className="relative group cursor-pointer p-1 border border-gray-200 rounded-lg bg-white hover:bg-gray-100 transition-all"
    //           >
    //             <Icons iconName={item.icon} height="25px" width="25px" />
    //             <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:flex flex-col items-center">
    //               <div className="bg-gray-900 text-white text-xs font-semibold px-3 py-1 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 max-w-[200px] truncate whitespace-nowrap">
    //                 {item.title ?? "Unknown"}
    //               </div>
    //               <div className="w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 mt-1" />
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     );
    //   },
    //   width: "20%",
    // },
    ,
    {
      field: "fromDate",
      label: <Label fontWeight="bold">Requested From</Label>,
      renderLogic: (row) => (
        <>
          <Heading
            type={HEADING.H4}
            customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }}
          >
            {row?.fromdate ? moment(row.fromdate).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading
            type={HEADING.H4}
            customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }}
          >
            {row?.fromdate ? moment(row.fromdate).format("LT") : <p className="text-center">-</p>}
          </Heading>
        </>
      ),
      width: "10%",
    },
    
    {
      field: "toDate",
      label: <Label fontWeight="bold">Requested To</Label>,
      renderLogic: (row) => (
        <>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }} fontSize="md">
            {row?.todate ? moment(row.todate).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md">
            {row?.todate ? moment(row.todate).format("LT") : <p className="text-center">-</p>}
          </Heading>
        </>
      ),
      width: "10%",
    },
    {
      field: "grantedFrom",
      label: <Label fontWeight="bold">Granted From</Label>,
      renderLogic: (row) => (
        <>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }} fontSize="md">
          {row?.grantFrom ? moment(row.grantFrom).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md" >
           {row?.grantFrom ? moment(row.grantFrom).format("LT") : <p className="text-center">-</p>}
          </Heading>
        </>
      ),
      width: "10%",
    },
    {
      field: "grantTo",
      label: <Label fontWeight="bold">Granted To</Label>,
      renderLogic: (row) => (
        <>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }} fontSize="md">
          {row?.grantTo ? moment(row.grantTo).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md" >
          {row?.grantTo ? moment(row.grantTo).format("LT") : <p className="text-center">-</p>}
          </Heading>
        </>
      ),
      width: "10%",
    },
    {
      field: "created_at",
      label: <Label fontWeight="bold">Consent Created On</Label>,
      renderLogic: (row) => (
        <>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" ,textWrap: "nowrap"}} fontSize="md">
            {row.dataEraseDate ? moment(row.created_at).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md">
            {row.dataEraseDate ? moment(row.created_at).format("LT") : <p className="text-center">-</p>}
          </Heading>
        </>
      ),
      width: "10%",
    },
    {
      field: "grantTime",
      label: <Label fontWeight="bold">Consent Granted On</Label>,
      renderLogic: (row) => (
        <>
          <Heading
            type={HEADING.H4}
            customStyle={{
              color: "#6B7280",
              fontSize: "14px",
              fontWeight: "500",
              textWrap: "nowrap"
            }}
            fontSize="md"
          >
             {row.grantedOn ? moment(row.grantedOn).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading
            type={HEADING.H4}
            customStyle={{
              color: "#6B7280",
              fontSize: "14px",
              fontWeight: "500",
            }}
            fontSize="md"
          >
            {row?.grantedOn && row?.grantedOn ? (
              moment(row.grantedOn).format("LT")
            ) : (
              <p className="text-center">-</p>
            )}
          </Heading>
        </>
      ),
      width: "10%",
    },
    {
      field: "expiryOn",
      label: <Label fontWeight="bold">Expiry Consent On</Label>,
      renderLogic: (row) => (
        <>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }} fontSize="md">
            {row.dataEraseDate ? moment(row.dataEraseDate).format("YYYY-MM-DD") : <p className="text-center">-</p>}
          </Heading>
          <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md">
            {row.dataEraseDate ? moment(row.dataEraseDate).format("LT") : <p className="text-center">-</p>}
          </Heading>
        </>
      ),
      width: "10%",
    },
    {
      field: "revokedOn",
      label: <Label fontWeight="bold">Consent Revoked On</Label>,
      renderLogic: (row) => (
        <>
        <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }} fontSize="md">
           {row.revokedOn ? moment(row.revokedOn).format("YYYY-MM-DD") : <p className="text-center">-</p>}
        </Heading>
        <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md">
            {row.revokedOn ? moment(row.revokedOn).format("LT") : <p className="text-center">-</p>}
          </Heading>
      </>
      ),
      width: "10%",
    },
    {
      field: "denied",
      label: <Label fontWeight="bold">Consent Denied On</Label>,
      renderLogic: (row) => (
        <>
        <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500",textWrap: "nowrap" }} fontSize="md">
            {row.deniedOn ? moment(row.deniedOn).format("YYYY-MM-DD") : <p className="text-center">-</p>}
        </Heading>
           <Heading type={HEADING.H4} customStyle={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }} fontSize="md">
           {row.deniedOn ? moment(row.deniedOn).format("LT") : <p className="text-center">-</p>}
         </Heading>
         </>
      ),
      width: "10%",
    },
    {
      field: "actions",
      label: <Label fontWeight="bold">View</Label>,
      renderLogic: (row) => {
        const disabledStatuses = ["Requested", "Revoked", "Denied", "Expired"];
        const isDisabled = disabledStatuses.includes(General.toPascalCaseWithSpaces(row?.status));
  
        return (
          <div className="flex gap-2">
            <Button
              variant={BUTTON_VARIANTS.TEXT}
              onClickCb={() => {
                if (!isDisabled) {
                  dispatch(getConsentRecordsList({ id: row.uuid }));
                  setIsViewRecordsOpen(true);
                  dispatch(setPatientId(row.patientId ))
                }
              }}
              disabled={isDisabled}
              customBtnClass={`bg-gray-200 text-black font-bold px-4 ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
            >
           View 
            </Button>
          </div>
        );
      },
      width: "10%",
    },
  ];
  

  return (
    <div className="h-full pb-4 flex flex-col gap-2 justify-between">
      {!(isViewRecordsOpen && bundlesData) ? (
        <div className="h-full flex flex-col p-2 justify-between">
          <div className="">
            <div className="flex justify-between gap-[16px]">
              <div className="flex items-center justify-between mb-1">
                <Heading fontSize="2xl" fontWeight="bold" type={HEADING.H1}>
                  Consent List
                </Heading>
              </div>

              <Button
                variant={BUTTON_VARIANTS.CONTAINED}
                onClickCb={hanldeResfresh}
                customBtnClass="text-met-primary mb-2"
              >
                Refresh
              </Button>
            </div>
            <Table
              coloumns={columns}
              rows={consentList.consent || []}
              paginationProps={{
                isPagination: true,
                totalCount: consentList.totalRecords,
                limit: 5,
                onPageChange: (page) => {
                  dispatch(setPaginationState({ pageNumber: page }));
                },
                currentPage: paginationState.pageNumber,
              }}
              customClass="overflow-x-auto"
            />
          </div>

          {/* <div className="flex justify-end">
            <Button
              onClickCb={handleABHAhealthRecord}
              variant={BUTTON_VARIANTS.OUTLINED}
            >
              Cancel
            </Button>
          </div> */}
        </div>
      ) : (
        <ViewRecords
          handleCancle={() => {
            setIsViewRecordsOpen(false);
          }}
          custumHeight="max-h-[86vh]"
        />
      )}
    </div>
  );
};

export default ConsentList;
